import { withInstall } from '@zoryn/utils'
import CheckTag from './src/check-tag.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZCheckTag: SFCWithInstall<typeof CheckTag> = withInstall(CheckTag)
export default ZCheckTag

export * from './src/check-tag'
